type CldOpts = {
  w?: number;
  h?: number;
  crop?: "fill" | "thumb" | "fit" | "scale";
  gravity?: "face" | "faces" | "auto" | "center";
  quality?: "auto" | number;
  format?: "auto" | "jpg" | "png" | "webp" | "avif";
  extra?: string[]; // for advanced flags if needed
};

const CLOUD_NAME = "ddstd8ero";
const ROOT_FOLDER = "expert-images";
const ROOT_FOLDER_2 = "expert-images-2";
const ROOT_FOLDER_3 = "expert-images-3";

export function cldUrl(path: string | null | undefined, opts: CldOpts = {}) {
  if (!path) return "";
  const {
    w,
    h,
    crop = "fill",
    gravity = "face",
    quality = "auto",
    format = "auto",
    extra = [],
  } = opts;

  const t: string[] = [];
  if (format) t.push(`f_${format}`);
  if (quality) t.push(`q_${quality}`);
  if (crop) t.push(`c_${crop}`);
  if (gravity) t.push(`g_${gravity}`);
  if (w) t.push(`w_${w}`);
  if (h) t.push(`h_${h}`);
  if (extra.length) t.push(...extra);

  const trans = t.join(",");
  const transPart = trans ? `${trans}/` : "";

  // If "https://desirelist-site-videos.s3.amazonaws.com/" in path then remove it
  if (path.startsWith("https://desirelist-site-videos.s3.amazonaws.com/")) {
    path = path.replace("https://desirelist-site-videos.s3.amazonaws.com/", "");
    
    // path should mirror your S3 key after the auto-upload mapping prefix
    return `https://res.cloudinary.com/${CLOUD_NAME}/image/upload/${transPart}${ROOT_FOLDER}/${path}`;
  } 

  else if (path.startsWith("https://dahcy03mzpux1.cloudfront.net/")) {
    path = path.replace("https://dahcy03mzpux1.cloudfront.net/", "");
    
    // path should mirror your S3 key after the auto-upload mapping prefix
    return `https://res.cloudinary.com/${CLOUD_NAME}/image/upload/${transPart}${ROOT_FOLDER_2}/${path}`;
  }

  else if (path.startsWith("https://desirelistofficial.s3.amazonaws.com/")) {
    path = path.replace("https://desirelistofficial.s3.amazonaws.com/", "");

    // path should mirror your S3 key after the auto-upload mapping prefix
    return `https://res.cloudinary.com/${CLOUD_NAME}/image/upload/${transPart}${ROOT_FOLDER_3}/${path}`;
  }

  // Else return external path
  return path;

  
}
